exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ui-state-hover, .ui-widget-content .ui-state-hover {\n    border: 1px solid #003eff/*{borderColorActive}*/;\n    background: #007fff/*{bgColorActive}*/ /*{bgImgUrlActive}*/ /*{bgActiveXPos}*/ /*{bgActiveYPos}*/ /*{bgActiveRepeat}*/;\n    font-weight: normal/*{fwDefault}*/;\n    color: #ffffff/*{fcActive}*/;\n}\n", ""]);

// exports
